import { render, staticRenderFns } from "./xww.vue?vue&type=template&id=7009f830&scoped=true"
import script from "./xww.vue?vue&type=script&lang=js"
export * from "./xww.vue?vue&type=script&lang=js"
import style0 from "./xww.vue?vue&type=style&index=0&id=7009f830&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7009f830",
  null
  
)

export default component.exports